import {stegaClean} from '@sanity/client/stega'

export const normalizeHost = (value: string): string => {
  if (!value) return ''
  const trimmed = value.trim()
  if (trimmed.includes('://')) {
    try {
      return new URL(trimmed).hostname.toLowerCase()
    } catch {
      return trimmed.toLowerCase().split(':')[0]
    }
  }
  return trimmed.toLowerCase().split(':')[0]
}

export const normalizeBasePath = (
  value: string | null | undefined,
  options?: {rootIsEmpty?: boolean},
): string => {
  if (!value) return options?.rootIsEmpty ? '' : '/'
  let basePath = stegaClean(value).trim()
  if (!basePath) return options?.rootIsEmpty ? '' : '/'
  if (!basePath.startsWith('/')) basePath = `/${basePath}`
  basePath = basePath.replace(/\/+$/, '')
  if (!basePath) return options?.rootIsEmpty ? '' : '/'
  if (basePath === '/') return options?.rootIsEmpty ? '' : '/'
  return basePath
}

export const normalizePathname = (
  value: string | null | undefined,
  options?: {allowUrl?: boolean},
): string => {
  if (!value) return '/'
  const trimmed = value.trim()
  if (!trimmed) return '/'
  if (options?.allowUrl && trimmed.includes('://')) {
    try {
      return new URL(trimmed).pathname || '/'
    } catch {
      return '/'
    }
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

export const matchesBasePath = (pathname: string, basePath: string): boolean => {
  if (!basePath) return true
  if (pathname === basePath) return true
  return pathname.startsWith(`${basePath}/`)
}

export const stripBasePath = (pathname: string, basePath: string): string => {
  if (!basePath) return pathname || '/'
  if (pathname === basePath) return '/'
  if (pathname.startsWith(`${basePath}/`)) {
    const remainder = pathname.slice(basePath.length)
    return remainder || '/'
  }
  return pathname || '/'
}
